/* global module */

module.exports = function emptyElement(el) {
	while (el && el.children.length) el.removeChild(el.children[0]);
	return el;
};
